// Updates the app icon badge of the installed PWA (Windows taskbar / macOS
// dock) via the Badging API. Silently no-ops where the API is not supported
// (regular browser tab, Firefox, etc.).
export const updateAppBadge = count => {
  if (!('setAppBadge' in navigator)) return;

  if (count > 0) {
    navigator.setAppBadge(count).catch(() => {});
  } else {
    navigator.clearAppBadge().catch(() => {});
  }
};
